// app/javascript/controllers/collapse_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["collapse", "content", "icon", "summary"]
    static values = { key: String }

    connect() {
        this.initializeCollapseState()

        // Restore persisted state for the new-style content target (opt-in via key value)
        if (this.hasKeyValue && this.hasContentTarget && localStorage.getItem(`collapse_${this.keyValue}`) === 'false') {
            this.contentTarget.classList.add('hidden')
            if (this.hasIconTarget) this.iconTarget.classList.remove('rotate-90')
            this.toggleSummaries(false)
        }
    }

    initializeCollapseState() {
        // Initialize old-style collapse targets with IDs
        this.collapseTargets.forEach(target => {
            const isExpanded = this.getStoredState(target.id)
            const button = this.element.querySelector(`[data-collapse-id="${target.id}"]`)
            // .bi-chevron-right = legacy font icon; .svg-icon--chevron-right = inline SVG
            const icon = button?.querySelector('.bi-chevron-right, .svg-icon--chevron-right')

            if (isExpanded) {
                target.classList.remove('hidden')
                icon?.classList.add('rotate-90')
            } else {
                target.classList.add('hidden')
                icon?.classList.remove('rotate-90')
            }
        })
    }

    toggle(event) {
        const button = event.currentTarget

        // Check if this is old-style with data-collapse-id
        const targetId = button.getAttribute('data-collapse-id')
        if (targetId) {
            const target = this.collapseTargets.find(t => t.id === targetId)
            const icon = button.querySelector('.bi-chevron-right, .svg-icon--chevron-right')
            const isExpanding = target.classList.contains('hidden')

            if (isExpanding) {
                target.classList.remove('hidden')
                icon.classList.add('rotate-90')
            } else {
                target.classList.add('hidden')
                icon.classList.remove('rotate-90')
            }

            this.storeState(targetId, isExpanding)
        } else {
            // New-style with content and icon targets
            if (this.hasContentTarget && this.hasIconTarget) {
                const isExpanding = this.contentTarget.classList.contains('hidden')

                if (isExpanding) {
                    this.contentTarget.classList.remove('hidden')
                    this.iconTarget.classList.add('rotate-90')
                } else {
                    this.contentTarget.classList.add('hidden')
                    this.iconTarget.classList.remove('rotate-90')
                }

                this.toggleSummaries(isExpanding)

                if (this.hasKeyValue) {
                    this.storeState(this.keyValue, isExpanding)
                }
            }
        }
    }

    // Summary targets are visible only while the content is collapsed
    toggleSummaries(isExpanded) {
        this.summaryTargets.forEach(target => {
            target.classList.toggle('hidden', isExpanded)
            target.classList.toggle('flex', !isExpanded)
        })
    }

    getStoredState(targetId) {
        return localStorage.getItem(`collapse_${targetId}`) === 'true'
    }

    storeState(targetId, isExpanded) {
        localStorage.setItem(`collapse_${targetId}`, isExpanded)
    }
}
